var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "_inputs" }, [
    _c("label", { attrs: { for: "minPriceInput" } }, [
      _vm._v("Fra kr.:\n    "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.minPrice,
            expression: "minPrice"
          }
        ],
        attrs: { id: "minPriceInput", type: "number" },
        domProps: { value: _vm.minPrice },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.minPrice = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("label", { attrs: { for: "maxPriceInput" } }, [
      _vm._v("Til kr.:\n    "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.maxPrice,
            expression: "maxPrice"
          }
        ],
        attrs: { id: "maxPriceInput", type: "number" },
        domProps: { value: _vm.maxPrice },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.maxPrice = $event.target.value
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }